import { createContext, useContext, useEffect, useState } from "react";
import { STR } from "../data/i18n";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("gpn-lang") || "fr");

  const setLang = (l) => {
    localStorage.setItem("gpn-lang", l);
    setLangState(l);
  };

  useEffect(() => {
    document.documentElement.lang = lang === "de" ? "de-CH" : "fr-CH";
    document.title = STR[lang].meta.title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", STR[lang].meta.description);
  }, [lang]);

  return <LangContext.Provider value={{ lang, setLang, S: STR[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
